import { render, staticRenderFns } from "./ApplicantMessageReservationReservedToApplicant.vue?vue&type=template&id=1d0f8786"
import script from "./ApplicantMessageReservationReservedToApplicant.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageReservationReservedToApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports